import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

export const servicesApi = createApi({
  reducerPath: "servicesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_API_URL}users/services`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Services"],
  endpoints: (builder) => ({
    getServices: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        category = "",
        type = "",
        status = "",
      }) => {
        const params = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
        });

        if (search) params.append("search", search);
        if (category) params.append("category", category);
        if (type) params.append("type", type);
        if (status !== "") params.append("status", status);

        return `?${params.toString()}`;
      },
      providesTags: ["Services"],
    }),

    addServices: builder.mutation({
      query: (formData) => ({
        url: "/",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Services"],
    }),

    updateService: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Services"],
    }),

    deleteService: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Services"],
    }),

    toggleServiceStatus: builder.mutation({
      query: (id) => ({
        url: `/${id}/status`,
        method: "PATCH",
      }),
      invalidatesTags: ["Services"],
    }),

    // Export endpoint
    exportServices: builder.query({
      query: ({ search = "", category = "", type = "", status = "" }) => {
        const params = new URLSearchParams({ exportExcel: "true" });

        if (search) params.append("search", search);
        if (category) params.append("category", category);
        if (type) params.append("type", type);
        if (status !== "") params.append("status", status);

        return `?${params.toString()}`;
      },
    }),
  }),
});

export const {
  useGetServicesQuery,
  useAddServicesMutation,
  useUpdateServiceMutation,
  useDeleteServiceMutation,
  useToggleServiceStatusMutation,
  useLazyExportServicesQuery,
} = servicesApi;
